export default class PageHeader {
    constructor($button) {
        this.$button = $button;
        this.$pageHeader = this.$button.closest('[data-page-header]');
        this.onClick = this.onClick.bind(this);
        this.$button.addEventListener('click', this.onClick);
    }

    onClick(e) {
        e.preventDefault();

        if (!this.$pageHeader) {
            return;
        }

        const $header = document.querySelector('[data-header]');
        const headerHeight = $header ? $header.getBoundingClientRect().height : 0;
        const extraOffset = 64;
        const targetY = this.$pageHeader.getBoundingClientRect().bottom + window.scrollY - headerHeight + extraOffset;

        window.scrollTo({
            top: targetY,
            behavior: 'smooth',
        });
    }
}
